<template>
    <div
        :class="{
            'pendo-banner': true,
            'no-padding': noPadding,
        }">
        <pendo-alert
            v-if="type"
            :closable="closable"
            :inline="true"
            :center="true"
            :type="type"
            :show-icon="false"
            @close="close">
            <div class="pendo-alert__content">
                <slot name="icon">
                    <div
                        v-if="icon"
                        class="alert__icon">
                        <pendo-icon
                            size="16"
                            :type="icon.type"
                            :stroke="icon.stroke" />
                    </div>
                </slot>
                <div class="banner-content-wrapper">
                    <slot />
                    <slot name="actions">
                        <div
                            v-if="buttonConfig"
                            class="alert__actions">
                            <pendo-button
                                v-for="(button, i) in buttonConfig"
                                :key="i"
                                :pendo-analytics="button.analyticsTag"
                                :data-cy="`${button.label}:button`"
                                :label="button.label"
                                :type="button.type"
                                :size="button.size"
                                :theme="button.theme || 'app'"
                                @click="button.action" />
                        </div>
                    </slot>
                </div>
            </div>
        </pendo-alert>
    </div>
</template>

<script>
import { PendoAlert, PendoButton, PendoIcon } from '@pendo/components';

export default {
    name: 'BannerAlert',
    components: {
        PendoAlert,
        PendoButton,
        PendoIcon,
    },
    props: {
        closable: {
            type: Boolean,
            default: true,
        },
        type: {
            type: String,
            default: 'info',
        },
        buttonConfig: {
            type: Array,
            default: () => [],
        },
        icon: {
            type: [Object, null],
            default: () => null,
        },
        noPadding: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close'],
    methods: {
        close () {
            this.$emit('close');
        },
    },
};
</script>

<style scoped lang="less">
.pendo-banner {
    &.no-padding {
        .pendo-alert {
            padding: 0;
        }
    }
    .alert__icon {
        margin-right: 16px;
        @media (max-width: 859px) {
            margin-top: 5px;
        }
    }
    .pendo-alert__title {
        margin-right: 4px;
    }
    .alert__desription {
        margin-right: 16px;
    }
    .alert__actions {
        display: flex;
        grid-gap: 10px;
    }
    .banner-content-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        grid-gap: 10px;
        @media (max-width: 859px) {
            flex-direction: column;
            justify-content: start;
            align-items: start;
        }
    }
    :deep(.pendo-alert) {
        border: none;
        border-radius: 0;
        padding: 8px 24px;
        &.is-inline {
            .pendo-alert__content {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                @media (max-width: 859px) {
                    justify-content: start;
                    align-items: start;
                }
            }
            .pendo-alert__description {
                display: inline-flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
}
</style>
